// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';

import style from './Benefits.scss';
import firstBenefit from '../../../../../assets/img/new-order/scrap-step/benefits/usa_stores.png';
import secondBenefit from '../../../../../assets/img/new-order/scrap-step/benefits/domestic_shipping.png';
import thirdBenefit from '../../../../../assets/img/new-order/scrap-step/benefits/warranty.png';

type Props = {};

export default class Benefits extends Component<Props> {
  render() {
    return (
      <Fragment>
        <FormattedMessage id="newOrder.scrap.benefits.title">{
          txt => <h2 className={style.title}>{txt}</h2>
        }</FormattedMessage>
        <section className={style.benefits}>
          <FormattedMessage id="newOrder.scrap.benefits.first">{
            txt => <article className={style.benefit}>
              <section className={style.imgWrap}>
                <img src={firstBenefit} alt="firstBenefit"/>
              </section>
              <p>{txt}</p>
            </article>
          }</FormattedMessage>
          <FormattedMessage id="newOrder.scrap.benefits.second">{
            txt => <article className={classNames(style.benefit, style.middle)}>
              <section className={style.imgWrap}>
                <img src={secondBenefit} alt="secondBenefit"/>
              </section>
              <p>{txt}</p>
            </article>
          }</FormattedMessage>
          <FormattedMessage id="newOrder.scrap.benefits.third">{
            txt => <article className={style.benefit}>
              <section className={style.imgWrap}>
                <img src={thirdBenefit} alt="thirdBenefit"/>
              </section>
              <p>{txt}</p>
            </article>
          }</FormattedMessage>
        </section>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/home/components/HomeLanding/Benefits/Benefits.jsx